import {stakeholderService} from '../services'

export default (countryCode, rut, verificationCode, newPassword) => {
	return new Promise((resolve, reject) => {

		stakeholderService.registerUser(countryCode, rut, verificationCode, newPassword)
			.then(response =>{
			 resolve({ success: true, data: response })
			})
      .catch(data => {
		  if(data.response.status === 500) {
			  reject({ success: false, data: data.response.data })
		  }else{
			  resolve({success: false, data: data.response})
		  }
	  })
	})
}
